import {
  Box,
  Button,
  ButtonProps,
  Container,
  IconButton,
  InputAdornment,
  Pagination,
  styled,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Breadcrumb from "../../../Shared-ui/SharedComponents/Breadcrumb";
import variables from "../../../assets/styles/variables.module.scss";
import AddIcon from "@mui/icons-material/Add";
import ToolCard from "../../../Shared-ui/SharedComponents/Cards/ToolCard";
import CreateTool from "../../Components/CreateTool";
import { useDispatch, useSelector } from "react-redux";
import { StartLoading, StopLoading } from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import { ShowError } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import BaseInstance from "../../../Services/AxiosInstance/BaseInstance";
import { TOOLS } from "../../../Services/Endpoint";
import Tool, { CalculatorTool, CrawlTool, CsvTool, PostgresTool, SQLTool } from "../../../Shared-ui/Types/Tool";
import Confirm from "../../../Shared-ui/Types/Confirm";
import ConfirmPopup from "../../../Shared-ui/SharedComponents/ConfirmPopup";
import SearchIcon from "@mui/icons-material/Search";
import Emptystateimage from "../../../assets/images/Agents_emptystateimage.svg"


const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
  // borderRadius: "8px",
  color: variables.whiteColor,
  backgroundColor: variables.primaryButton,
  "&:hover": {
    backgroundColor: variables.primaryColor,
  },
}));

const Tools = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useDispatch()
  const [tools, setTools] = useState<(CalculatorTool | CrawlTool | PostgresTool | SQLTool | CsvTool)[]>([])
  const [toolsAll, setToolsAll] = useState<(CalculatorTool | CrawlTool | PostgresTool | SQLTool | CsvTool)[]>([])
  const [tool, setTool] = useState<any>(null)
  const [open, setOpen] = useState(false);
  const [searchText, setSearchText] = useState<string>("")
  const [confirmPopupData, setConfirmPopupData] = useState<Confirm>({ show: false })

  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(8)
  const [totalTools, setTotalTools] = useState(0);
  const prevPage = useRef<number>(page);
  const pageLimitRef = useRef(8)
  const loaderStatus = useSelector((state: any) => state.LoaderReducer);
  const [filteredTools, setFilteredTools] = useState<(CalculatorTool | CrawlTool | PostgresTool | SQLTool | CsvTool)[]>([]);


  // useEffect(() => {
  //   getTools()
  // }, [])

  useEffect(() => {
    if (!searchText) {
      setPage(1);
      getTools();
    }
  }, [searchText]);


  useEffect(() => {
    if (prevPage.current !== page) {
      getTools();
      prevPage.current = page;
    }
  }, [page]);

  const getTools = async (searchText?: string) => {
    try {
      dispatch(StartLoading("Tool"));
      var url = `${TOOLS}?page=${page}&page_size=${limit}`
      if (searchText) {
        url += `&search=${searchText}`;
      }
      const data = await BaseInstance.get(url).then(
        (res) => res?.data
      );
      // data?.items?.sort((a: { created_at: string }, b: { created_at: string }) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
      setTools(data.items)
      setTotalTools(data.pagination.total || 0)
      // setToolsAll(data)
      // paginatedLocally(data)
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading("Tool"));
    }

  }

  const deleteTool = async (tool: Tool) => {
    try {
      setConfirmPopupData((preVal) => ({ ...preVal, show: false }));
      dispatch(StartLoading());
      const data = await BaseInstance.delete(`${TOOLS}/${tool.id}`).then(
        (res) => res?.data
      );
      getTools()
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading());
    }

  }
  const confirmDelete = (row: Tool) => {
    setConfirmPopupData({
      show: true,
      setConfirmPopupData: setConfirmPopupData,
      title: "Confirm Delete",
      info: "Are you sure you want to delete the Tool? This action cannot be undone.",
      varient: "delete",
      functionName: deleteTool,
      functionParam: row
    })
  }

  const editingTool = (tool: Tool) => {
    setOpen(true)
    setTool(tool)
  }

  const handleClose = () => {
    setOpen(false)
    setTool(null)
    getTools()
  }

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPage(value);
  };

  const handleSearch = () => {
    setPage(1);
    getTools(searchText);

  };


  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          mb: { xs: 3, sm: 0 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: { md: "flex-end", sm: "flex-start" },
            gap: { md: "10px", sm: "0" },
            flexDirection: { md: "row", sm: "column", xs: "column" },
          }}
        >
          <Breadcrumb data={[{ name: "Connections", path: "" }]} />
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: { xs: 1, sm: 2 },
            width: { xs: "100%", sm: "400px", md: "auto" },
          }}
        >
          <TextField
            placeholder="Search Connections"
            variant="outlined"
            size="small"
            sx={{
              width: { xs: "100%", sm: "350px" },
              flex: { xs: 1, sm: 1, md: "none" },
            }}
            onChange={(e) => setSearchText(e.target.value)}
            value={searchText}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleSearch} // your custom function
                    edge="end"
                    size="small"
                  >
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <ColorButton
            variant="contained"
            disableElevation
            startIcon={<AddIcon />}
            size={isSmallScreen ? "small" : "large"}
            sx={{
              textTransform: "capitalize",
              fontWeight: "400",
              whiteSpace: "nowrap",
              borderRadius: { sm: "8px", xs: "4px" },
              height: "40px",
              "& .MuiButton-startIcon": {
                mr: { xs: 0, sm: 1 },
              },
            }}
            onClick={() => setOpen(true)}
          >
            {!isSmallScreen && "Create Connection"}
          </ColorButton>
        </Box>
      </Box>

      {tools.length > 0 && (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xl: "1fr 1fr 1fr 1fr",
              lg: "1fr 1fr 1fr 1fr",
              md: "1fr 1fr 1fr",
              sm: "1fr 1fr",
            },
            gap: 3,
            gridAutoRows: "1fr",
          }}
        >
          {tools.map((tool, index) => (
            <ToolCard
              key={index}
              data={tool}
              deleteFun={confirmDelete}
              editFun={editingTool}
            />
          ))}
        </Box>
      )}

      {tools.length === 0 && totalTools === 0 && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mt: 6,
          }}
        >

          {loaderStatus.isLoading && loaderStatus.pageName === "Tool" && (
            <>
              <img
                src={Emptystateimage}
                alt="No Connections Found"
                style={{ width: 120, height: "auto" }}
              />
              <Typography variant="h6" color="text.secondary">
                Connections loading...
              </Typography>
            </>
          )}
          {!loaderStatus.isLoading && loaderStatus.pageName === "Tool" && (
            <>
              <img
                src={Emptystateimage}
                alt="No Connections Found"
                style={{ width: 120, height: "auto" }}
              />
              <Typography variant="h6" color="text.secondary">
                No Connections Found
              </Typography>
            </>
          )}
        </Box>
      )}

      {/* Pagination */}

      {totalTools > limit && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 3,
          }}
        >
          <Pagination
            count={Math.ceil(totalTools / limit)}
            page={page}
            onChange={handlePageChange}
            variant="outlined"
            shape="rounded"
          />
        </Box>
      )}
      {/* Create Tool Dialog */}
      <CreateTool open={open} onClose={handleClose} tool={tool} />
      <ConfirmPopup details={confirmPopupData} />
    </Container>
  );
};

export default Tools;
